import { render } from "./MobileWarn.vue?vue&type=template&id=0295a710"
import script from "./MobileWarn.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileWarn.vue?vue&type=script&setup=true&lang=js"

import "./MobileWarn.vue?vue&type=style&index=0&id=0295a710&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MobileWarn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0295a710"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0295a710', __exports__)) {
    api.reload('0295a710', __exports__)
  }
  
  module.hot.accept("./MobileWarn.vue?vue&type=template&id=0295a710", () => {
    api.rerender('0295a710', render)
  })

}


export default __exports__